var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zedplan-player player",attrs:{"data-vjs-player":""}},[_c('video',{ref:"player",staticClass:"video-js vjs-default-skin vjs-big-play-centered",attrs:{"width":"100%","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }